module.exports = __webpack_public_path__ + "static/girl_with_phone-0fd682bf94b2348215061a4523a9d547.jpg";